import React from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import CountrySelect from "./CountrySelect";
import { useGetCountries } from "../../../APICalling/useApiQueries";

const PhoneNumberInput = ({
  placeholder = "",
  defaultCountry = "SG",
  international = true,
  value,
  onChange,
  onCountryChange,
  onCallingCodeValidation,
  editableCallingCode = false,
  className = "form-control",
  ...inputProps
}) => {
  const { data: directory, isPending, isError, refetch } = useGetCountries();
  const availableDefault = !directory || directory.codes.includes(defaultCountry)
    ? defaultCountry
    : undefined;

  return (
    <PhoneInput
      {...inputProps}
      placeholder={placeholder}
      defaultCountry={availableDefault}
      countries={directory?.codes}
      international={international}
      value={value || undefined}
      onChange={onChange}
      onCountryChange={onCountryChange}
      className={className}
      countrySelectComponent={CountrySelect}
      countrySelectProps={{
        directory,
        countriesLoading: isPending && !directory,
        countriesError: isError && !directory,
        onRetryCountries: refetch,
        onValidationChange: onCallingCodeValidation,
        editableCallingCode,
      }}
    />
  );
};

export default PhoneNumberInput;
